import { APIClient } from "@velzon/utils/axios/api_helper.js";

const AxiosClient = new APIClient()
const userList = (query) => AxiosClient.get(`/user/list${query}`)
const statusUpdate = (payload) => AxiosClient.post(`/user/status-update`, payload)
const exportUsers = (format) =>
  AxiosClient.get(
    '/user/export',
    { format },
    {
      responseType: 'blob',
      headers: {
        Accept: 'text/csv, application/pdf'
      },
      useParamsSerializer: true
    }
  );

export {
  userList,
  statusUpdate,
  exportUsers
}